// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"81b13168","99":"8d265a05","146":"8b261ca8","175":"ad4b66cc","204":"a82e32f6","349":"c46c69e6","479":"1317dacf","655":"e5607540","674":"8f9e1ea3","768":"9405f1d1","813":"ab89fe9a","963":"549eff22"}[chunkId] + ".chunk.js";
};